import { render } from "./OrderPerformance.vue?vue&type=template&id=8f7a30ec&scoped=true&ts=true&lang=pug"
import script from "./OrderPerformance.vue?vue&type=script&lang=ts"
export * from "./OrderPerformance.vue?vue&type=script&lang=ts"

import "./OrderPerformance.vue?vue&type=style&index=0&id=8f7a30ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7a30ec"]])

export default __exports__